import { useState, useEffect, createContext, useContext } from 'react'

type Lang = 'zh' | 'en'

interface I18nContextType {
  lang: Lang
  toggleLang: () => void
  t: (zh: string, en: string) => string
}

export const I18nContext = createContext<I18nContextType>({
  lang: 'zh',
  toggleLang: () => {},
  t: (zh: string, _en: string) => zh,
})

export function useI18n() {
  return useContext(I18nContext)
}

export function useI18nProvider() {
  const [lang, setLang] = useState<Lang>(() => {
    const saved = localStorage.getItem('lang')
    return (saved === 'en' || saved === 'zh') ? saved : 'zh'
  })

  useEffect(() => {
    localStorage.setItem('lang', lang)
    document.documentElement.lang = lang
  }, [lang])

  const toggleLang = () => setLang((prev) => (prev === 'zh' ? 'en' : 'zh'))

  const t = (zh: string, en: string) => (lang === 'zh' ? zh : en)

  return { lang, toggleLang, t }
}
